import React from "react";
import {SvgIcon} from "@mui/material";
import {LoadingButton} from "@mui/lab";

// El boton de exportar a Excel de todo Haulers: el verde del tema (el mismo de "Importar
// Excel"), con el icono de planilla y el mismo texto en todas las pantallas. Tipografia y
// sombra son las de cualquier boton de la app, para que conviva con los de al lado.

// Planilla con la X de Excel. MUI no trae un icono de Excel.
export const ExcelIcon = (props) => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path fill="currentColor" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zm4 18H6V4h7v5h5z"/>
        <path fill="currentColor" d="M8.4 11h2l1.6 2.6 1.6-2.6h2l-2.6 4 2.6 4h-2L12 16.4 10.4 19h-2l2.6-4z"/>
    </SvgIcon>
);

const ExcelExportButton = ({
    onClick,
    loading = false,
    disabled = false,
    label = "Exportar Excel",
    loadingLabel = "Exportando…",
    size = "medium",
    sx,
    ...rest
}) => (
    <LoadingButton
        variant="contained"
        color="success"
        size={size}
        loading={loading}
        loadingPosition="start"
        startIcon={<ExcelIcon/>}
        disabled={disabled}
        onClick={onClick}
        sx={{whiteSpace: "nowrap", flexShrink: 0, ...sx}}
        {...rest}
    >
        {loading ? loadingLabel : label}
    </LoadingButton>
);

export default ExcelExportButton;
